import React, {Component} from 'react';
import ChatAdmin from './admin';
import ChatDentist from './dentist';
import {connect} from 'react-redux';
import {setCurrentDentist} from '../../containers/Chat/actions';

class ChatWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMinimized: true,
            message: '',
            subject: '',
            selectedUser: props.isSingleChat ? 1 : 0,
            searchInputValue: '',
            hasNotification: false,
            page: 0,
            isScrolledToBottom: true,
        }
        this.handleLoadMore = this.handleLoadMore.bind(this);
    }

    scrollToBottom = (element) => {
        if (element) {
            element.scrollIntoView()
        }
    };

    handleScroll = (element) => {
        this.setState({isScrolledToBottom: element.scrollHeight === Math.ceil(element.offsetHeight + element.scrollTop) || element.scrollHeight === Math.floor(element.offsetHeight + element.scrollTop)});
    };

    componentDidMount() {
        this.props.getNumberOfUnreadMessages();
        if (this.state.selectedUser) {
            this.props.getMessages(this.state.selectedUser, this.state.page);
        }
    }

    addNewMessage = (e) => {
        const {message, selectedUser} = this.state;
        let messageToSend = message.replace(/\n/g, '\\n').replace(/\s/g, '\\s');
        if (message && selectedUser && message.replace(/\s/g, '').length && message.replace(/\n/g, '').length) {
            this.props.sendMessage(messageToSend, selectedUser);
            this.setState({message: ''});
        }
    };

    handleMessageChange = (e) => {
        this.setState({[e.target.name]: e.target.value});
    };

    toggleMinimizedState = () => {
        const unreadMessage = this.props.messages.filter(message => {
            if (!message.is_read && message.to === this.props.currentUser.id) {
                return message.id
            }
        });
        if (unreadMessage && unreadMessage[unreadMessage.length - 1]) {
            this.props.handleReadMessage(unreadMessage[unreadMessage.length - 1].id)
        }
        this.setState({isMinimized: !this.state.isMinimized});
    };

    handleSelectUser = (user) => {
        if(!user) {
            this.setState({selectedUser: 0});
        }else if (this.props.adminIsOnline && this.props.chatData.currentDentist !== user.id) {
            const page = 0;
            this.setState({selectedUser: user.id, page});
            this.props.handleClickConnect(user.id);
            this.props.setCurrentDentist(user);
            this.props.resetMessages();
            this.props.getMessages(user.id, page);
        } else if(!this.props.adminIsOnline && this.props.chatData.currentDentist !== user.id) {
            const page = 0;
            this.setState({selectedUser: user.id, page});
            this.props.setCurrentDentist(user);
            this.props.resetMessages();
            this.props.getMessages(user.id, page);
        }
        if(user && user.message_id) {
            this.props.handleReadMessage(user.message_id);
        }
    };

    handleSearchInputChange = (e) => {
        this.setState({searchInputValue: e.target.value});
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.addNewMessage(e);
        }
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.numberOfMessages < nextProps.numberOfMessages && this.props.isSingleChat) {
            this.setState({hasNotification: true});
        }
    }

    resetHasNotification = () => {
        this.setState({hasNotification: false});
    };

    toggleOnlineMode = () => {
        if (this.props.adminIsOnline) {
            this.props.leaveChatRoom();
        } else {
            this.props.joinChatRoom();
        }
    };

    handleLoadMore() {
        if (!this.props.noMoreMessages) {
            const page = this.state.page + 1;
            this.props.getMessages(this.props.chatData.currentDentist.id ? this.props.chatData.currentDentist.id : this.props.chatData.partnerId , this.props.messages.reduce((prev, curr) => prev.id < curr.id ? prev : curr).id);
            this.setState({page});
        }
    };

    render() {
        const {isMinimized, message, searchInputValue, selectedUser, hasNotification} = this.state;
        const {chatData: {currentDentist},messages, currentUser, isSingleChat, onlineUsers, users, adminIsOnline, numberOfMessages, noMoreMessages, loadingMessages, addedMessage, auth: {currentUser: {role}}} = this.props;
        const unreadMessage = messages.filter(message => {
            if (!message.is_read && message.to === currentUser.id) {
                return message.id
            }
        });
        return isSingleChat ?
                <ChatDentist isMinimized={isMinimized}
                adminIsOnline={adminIsOnline}
                selectedUser={selectedUser}
                currentUser={currentUser}
                unreadMessage={unreadMessage}
                toggleMinimizedState={this.toggleMinimizedState}
                addNewMessage={this.addNewMessage}
                handleKeyPress={this.handleKeyPress}
                handleMessageChange={this.handleMessageChange}
                resetHasNotification={this.resetHasNotification}
                hasNotification={hasNotification}
                messages={messages}
                message={message}
                handleLoadMore={this.handleLoadMore}
                numberOfMessages={numberOfMessages}
                noMoreMessages={noMoreMessages}
                loadingMessages={loadingMessages}
                scrollToBottom={this.scrollToBottom}
                handleScroll={this.handleScroll}
                isScrolledToBottom={this.state.isScrolledToBottom}
                addedMessage={addedMessage}
                 />              
                : 
            <div className="view">
                <ChatAdmin isMinimized={isMinimized}
                           activeUser={currentDentist}
                           adminIsOnline={adminIsOnline}
                           onlineUsers={onlineUsers}
                           selectedUser={currentDentist.id && selectedUser || ''}
                           users={users}
                           toggleMinimizedState={this.toggleMinimizedState}
                           searchInputValue={searchInputValue}
                           currentUser={currentUser}
                           toggleOnlineMode={this.toggleOnlineMode}
                           handleSearchInputChange={this.handleSearchInputChange}
                           handleSelectUser={this.handleSelectUser}
                           addNewMessage={this.addNewMessage}
                           handleKeyPress={this.handleKeyPress}
                           handleMessageChange={this.handleMessageChange}
                           messages={messages}
                           message={message}
                           hasNotification={hasNotification}
                           resetHasNotification={this.resetHasNotification}
                           handleLoadMore={this.handleLoadMore}
                           noMoreMessages={noMoreMessages}
                           loadingMessages={loadingMessages}
                           scrollToBottom={this.scrollToBottom}
                           handleScroll={this.handleScroll}
                           isScrolledToBottom={this.state.isScrolledToBottom}
                           addedMessage={addedMessage}
                           handleReadMessage={this.props.handleReadMessage}
                           numberOfMessages={numberOfMessages}
                />
            </div>

    }
}
const mapStateToProps = (state) => {
    return ({
    auth: state.auth,
    chatData: state.chatData
})}
const mapDispatchToProps = (dispatch) => ({
    setCurrentDentist: (dentist) => dispatch(setCurrentDentist(dentist))
})  

export default connect(mapStateToProps, mapDispatchToProps)(ChatWrapper)


// WEBPACK FOOTER //
// ./src/components/Chat/index.js